import { validate, ModelValidateResult } from "../api/validate"

export interface PhoneViewModel {
    url: string
}

export interface PhoneViewModelResp {
    url: string
    iphone_base64: string
}

const phoneViewModelConstraints = [{ field: "url", type: "string" }]

const phoneViewModelRespConstraints = [
    { field: "url", type: "string" },
    { field: "iphone_base64", type: "string" },
]

export const ValidatePhoneViewModel = (n: any): ModelValidateResult<PhoneViewModel> => {
    return validate<PhoneViewModel>(n, phoneViewModelConstraints)
}

export const ValidatePhoneViewRespModel = (n: any): ModelValidateResult<PhoneViewModelResp> => {
    return validate<PhoneViewModelResp>(n, phoneViewModelRespConstraints)
}
